"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import {
  Box,
  HStack,
  Icon,
  SimpleGrid,
  Stack,
  VStack,
  AspectRatio,
} from "@chakra-ui/react";
import { Balancer } from "react-wrap-balancer";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import ContactGif from "public/contactForm/Contact-us.gif";
import { CONTACT_FORM_CONSTANTS, CONTACT_LIST } from "./contactForm.constants";
import dynamic from "next/dynamic";

const HubspotContactForm = dynamic(() => import("./components/hubspot"), {
  ssr: false,
  loading: () => <Box minH="540px" bg="gray.100" borderRadius="8px" />,
});

type Props = {
  showContactInfoOnMobile?: boolean;
};

const ContactForm = (props: Props) => {
  const { showContactInfoOnMobile = true } = props;
  return (
    <Box my={"2rem"} id="contact-us">
      <VStack gap={"1.5rem"}>
        <Heading as="h3" variant={useHeadingVariant()}>
          Contact Us
        </Heading>
        <Text variant={"body2"} color="text.100" textAlign={"center"}>
          <Balancer>Innovative Tech Solutions and Expert Opinions</Balancer>
        </Text>
      </VStack>
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 2 }}
        gap={{ base: 6, md: 6 }}
        px={{ base: 0, md: 4 }}
      >
        <VStack>
          <Box padding={{ base: 0, sm: "2rem" }}>
            <AspectRatio
              position="relative"
              ratio={10 / 8}
              width={{ base: "100%", sm: "350px" }}
              maxW="350px"
            >
              <Image
                alt="Animated contact us illustration"
                fill
                src={ContactGif}
                style={{
                  objectFit: "cover",
                  objectPosition: "center",
                }}
                loading="lazy"
              />
            </AspectRatio>
          </Box>
          <Box
            display={showContactInfoOnMobile ? "flex" : { base: "none", md: "flex" }}
            flexDirection={{ base: "column", md: "row" }}
            gap="20px"
            minH="200px"
            py={4}
          >
            <Stack borderRadius="8px" boxShadow="lg" p="20px" flex="1">
              <Heading
                as="h4"
                color={"primary.200"}
                textAlign={"center"}
                mb={2}
                variant={"subTitle1"}
              >
                {CONTACT_FORM_CONSTANTS.UNITED_STATES}
              </Heading>
              {CONTACT_LIST.map((contact, index) => {
                return (
                  <HStack key={index}>
                    <Icon as={contact.icon} color="primary.200" fontSize="20px" />
                    <Link href={contact.path} target="_blank">
                      <Text
                        variant="body1"
                        color="text.100"
                        _hover={{ color: "primary.200", textDecoration: "underline" }}
                      >
                        {contact.label}
                      </Text>
                    </Link>
                  </HStack>
                );
              })}
            </Stack>
          </Box>
        </VStack>
        <Box alignSelf="center" width="100%">
          <HubspotContactForm />
        </Box>
      </SimpleGrid>
    </Box>
  );
};

export default ContactForm;
